function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgMotor = function SvgMotor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M20.156 22.523L16 18.366l-4.156 4.157a2.5 2.5 0 11-.783-.632l4.232-4.232-4.658-4.658-3.353 3.353a.5.5 0 01-.707 0l-2.828-2.829a.5.5 0 010-.707l7.071-7.071a.5.5 0 01.707 0l2.829 2.828a.5.5 0 010 .707l-3.012 3.012L16 16.952l4.658-4.658-3.012-3.012a.5.5 0 010-.707l2.829-2.828a.5.5 0 01.707 0l7.071 7.071a.5.5 0 010 .707l-2.828 2.829a.5.5 0 01-.707 0L21.365 13l-4.658 4.658 4.232 4.232a2.501 2.501 0 11-.783.632zm.672-15.715l-2.12 2.12 6.363 6.365 2.121-2.121-6.364-6.364zM21.89 5.04a.5.5 0 01.707-.707l7.071 7.07a.5.5 0 01-.707.708L21.89 5.04zm1.414-1.414a.5.5 0 11.707-.707l7.071 7.07a.5.5 0 01-.707.708l-7.07-7.071zM8.853 25.173a1.5 1.5 0 102.122-2.121 1.5 1.5 0 00-2.121 2.121zm2.319-18.365l-6.364 6.364 2.12 2.12 6.365-6.363-2.121-2.121zM10.11 5.04L3.04 12.11a.5.5 0 01-.707-.706l7.07-7.071a.5.5 0 11.708.707zM8.697 3.626l-7.071 7.07a.5.5 0 11-.707-.706l7.07-7.071a.5.5 0 11.708.707zm14.45 21.547a1.5 1.5 0 10-2.122-2.121 1.5 1.5 0 002.121 2.121z"
  }));
};

SvgMotor.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMotor.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMotor;